import { getLocale, getLocaleData, translate } from '@wec-core/helpers';

import enUS from './config/en_us.json';

const localisation = {
  en: enUS,
};

const localStorageKey = 'lang';

export const translation = (
  id: string,
  replaceMap?: { [key: string]: string | number }
) => {
  const localeData = getLocaleData(localisation, getLocale(localStorageKey));

  return translate({ ...localeData }[id], replaceMap);
};
